import { atom, useAtom, useSetAtom } from "jotai";
import { atomFamily } from "jotai-family";
import { ReactNode } from "react";
import { DialogId } from "./ConfirmDialog.stateIds";

export interface PublicConfirmDialogState {
  title: ReactNode;
  description?: ReactNode;
  confirmText: ReactNode;
  onCancel?: () => void;
}

interface ConfirmDialogState extends PublicConfirmDialogState {
  promise: { resolve: (c: boolean) => void } | undefined;
}

const confirmDialogAtomFamily = atomFamily((_id: DialogId) =>
  atom<ConfirmDialogState>({
    title: null,
    description: null,
    confirmText: null,
    onCancel: () => undefined,
    promise: undefined,
  })
);

export const useConfirmDialogState = (dialogId: DialogId) => {
  return useAtom(confirmDialogAtomFamily(dialogId));
};

export const useSetConfirmDialogState = (dialogId: DialogId) => {
  return useSetAtom(confirmDialogAtomFamily(dialogId));
};
